import { ButtonProps } from "../../types/types";

const Button = ({ className, children, disabled, onClick, type }: ButtonProps) => {
    return <button className={` ${className} h-11 rounded-md  font-normal`} type={type} disabled={disabled} onClick={onClick}>{children}</button>;
};

export default Button;